import React from 'react';
import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { CONVERSION_PROJECT } from '../../../constants';
import YesAndNo from '../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function ConversionProject({ section, setSectionValues }: Props) {
  function onNoConversion(): void {
    setSectionValues({
      [CONVERSION_PROJECT.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesConversion(): void {
    setSectionValues({
      [CONVERSION_PROJECT.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      required
      label={
        <Label>
          Do you know if the property has been approved for a condominium project, community apartment project, or stock
          cooperative project through a local zoning process?
        </Label>
      }
      control={
        <YesAndNo
          yesHandler={onYesConversion}
          noHandler={onNoConversion}
          yesActive={section.getFieldValue(CONVERSION_PROJECT.FIELD_NAME.IS_ENABLED)}
        />
      }
      description={
        <FormHelp>
          If yes, the rental unit may be sold to the public, and if it is offered for sale, the lease may be terminated.
          If the unit is to be sold, the current tenant must be given at least 90 days notice and right of first refusal
          to purchase the unit.
        </FormHelp>
      }
    />
  );
}

ConversionProject.description = 'Conversion project disclosure on the sale of the property';

export default ConversionProject;
